export default __webpack_public_path__ + "static/subset-UniNeueHeavy-Italic-b9f43047c2e31d14952bcbea2e155aab.woff";